import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-setting-projects',
  templateUrl: './setting-projects.component.html',
  styleUrl: './setting-projects.component.scss'
})
export class SettingProjectsComponent implements OnInit {
  breadCrumbItems!: Array<{}>;
 
   //permissão
   podeEditar = false;
   podeVer = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Configurações" },
      { label: "Documentos", active: true },
    ];

    this.permissaoAdicionarUsuario();
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Doc_Configuracoes', 'Editar')
    this.podeVer = this.authService.verificarPermissao('Doc_Configuracoes', 'Ver')
  }
}
